import { TASKS } from "../actions/actionsTypes";
import { IGlobal } from "../models/global.interface";
import { IActionBase } from "../models/root.interface";

const initialState: any = {
  tasksList: null,
  closeTask: null,
  postOpenTaskData: null,
  documentReports: null,
  reviewDocuments: null,
  downloadOpenTasks: null
};

function tasksReducer(state: any = initialState, action: IActionBase): IGlobal {
  switch (action.type) {
    case TASKS.GET_TASKS_FETCHING:
      return {
        ...state,
        tasksList: { loading: true, data: null, err: null },
        closeTask: null,
      };
    case TASKS.GET_TASKS_SUCCESS:
      return {
        ...state,
        tasksList: { loading: false, data: action.payload.data.data, err: null }
      };
    case TASKS.GET_TASKS_ERROR:
      return {
        ...state,
        tasksList: { loading: false, data: null, err: action.payload.error }
      };
    case TASKS.GET_DOCUMENT_REPORT_FETCHING:
      return {
        ...state,
        documentReports: { loading: true, data: null, err: null },
      };
    case TASKS.GET_DOCUMENT_REPORT_SUCCESS:
      return {
        ...state,
        documentReports: { loading: false, data: action.payload.data.data, err: null }
      };
    case TASKS.GET_DOCUMENT_REPORT_ERROR:
      return {
        ...state,
        documentReports: { loading: false, data: null, err: action.payload.error }
      };
    case TASKS.SET_DOCUMENT_REPORT:
      return {
        ...state,
        documentReports: null
      };
    case TASKS.CLOSE_TASKS_FETCHING:
      return {
        ...state,
        closeTask: { loading: true, data: null, err: null }
      };
    case TASKS.CLOSE_TASKS_SUCCESS:
      return {
        ...state,
        closeTask: { loading: false, data: action.payload, err: null }
      };
    case TASKS.CLOSE_TASKS_ERROR:
      return {
        ...state,
        closeTask: { loading: false, data: null, err: action.payload.error }
      };
    case TASKS.POST_TASKS_FETCHING:
      return {
        ...state,
        postOpenTaskData: { loading: true, data: null, err: null }
      };
    case TASKS.POST_TASKS_SUCCESS:
      return {
        ...state,
        postOpenTaskData: { loading: false, data: action.payload, err: null }
      };
    case TASKS.POST_TASKS_ERROR:
      return {
        ...state,
        postOpenTaskData: { loading: false, data: null, err: action.payload.error }
      };
      case TASKS.POST_REVIEW_TASKS_FETCHING:
      return {
        ...state,
        reviewDocuments: { loading: true, data: null, err: null }
      };
    case TASKS.POST_REVIEW_TASKS_SUCCESS:
      return {
        ...state,
        reviewDocuments: { loading: false, data: action.payload, err: null }
      };
    case TASKS.POST_REVIEW_TASKS_ERROR:
      return {
        ...state,
        reviewDocuments: { loading: false, data: null, err: action.payload.error }
      };

    case TASKS.DOWNLOAD_TASKS_FETCHING:
      return {
        ...state,
        downloadOpenTasks: { loading: true, data: null, err: null }
      };

    case TASKS.DOWNLOAD_TASKS_SUCCESS:
      return {
        ...state,
        downloadOpenTasks: { loading: false, data: action.payload, err: null }
      };
    case TASKS.DOWNLOAD_TASKS_ERROR:
      return {
        ...state,
        downloadOpenTasks: { loading: false, data: null, err: action.payload.error }
      };
    

    default:
      return state;
  }
};

export default tasksReducer;
